import { render, staticRenderFns } from "./CheckedPrimary.vue?vue&type=template&id=68374c32"
import script from "./CheckedPrimary.vue?vue&type=script&lang=js"
export * from "./CheckedPrimary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports